/** NRC IRAP checklist. */
export const IRAP_TASKS = [
  {
    id: 1,
    name: "Initial assessment",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Confirm IRAP eligibility with ITA", completed: false },
      { id: "1-2", name: "Schedule intro call with client", completed: false },
      { id: "1-3", name: "Define project scope and budget", completed: false },
    ],
  },
  {
    id: 2,
    name: "Application preparation",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Draft project description and milestones", completed: false },
      { id: "2-2", name: "Prepare financial projections", completed: false },
      { id: "2-3", name: "Internal review before submission", completed: false },
    ],
  },
  {
    id: 3,
    name: "Submit & manage project",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Submit application to IRAP", completed: false },
      { id: "3-2", name: "Set up reporting cadence if approved", completed: false },
    ],
  },
];
